<div
  class="flex flex-wrap gap-3 ms-3 p-4"
  [ngClass]="
    fields?.style?.position == 'center'
      ? 'justify-content-center'
      : 'justify-content-end'
  "
  *ngIf="fields"
>
  <button
    type="button"
    [ngStyle]="fields.properties.style"
    (click)="onClick(fields)"
    class="rounded-md px-4 py-2 btn btn-sm text-sm btn-primary font-medium transition-all"
  >
    {{ fields.displayName }}
  </button>
</div>

<div
  class="modal"
  data-modal="true"
  data-modal-disable-scroll="false"
  id="domain_modal"
>
  <div class="modal-content bg-white dark:bg-coal-500">
    <div class="modal-header pr-2.5">
      <span class="font-semibold text-base ms-2">{{ modalTitle }}</span>
      
    </div>
    <div class="modal-body grid gap-5 px-0 w-500px" *ngIf="activeModalContext">
      <app-modal-renderer
        *ngIf="nodeId"
        [nodeId]="nodeId"
        (header)="setModalTitle($event)"
        (formSaved)="onModalFormSaved($event)"
        (closeModal)="closeModal()"
        [noRecord]="noRecord"
      ></app-modal-renderer>
    </div>
  </div>
</div>
